module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-select-account"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title
    }
  }), _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [_c('account-list', {
    attrs: {
      "accounts": _vm.accounts
    },
    on: {
      "account-selected": _vm.onAccountSelected
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e3ad059","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/SelectAccount/SelectAccount.vue
// module id = 596
// module chunks = 1